var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-switch',{attrs:{"label":_vm.$t('incidentReports.incidentReportFormLong.eyewitness')},model:{value:(_vm.value.eyewitness),callback:function ($$v) {_vm.$set(_vm.value, "eyewitness", $$v)},expression:"value.eyewitness"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }